export default class MatchOddsMarketScopeModel {
  public id: string = null;
  public type: string = null;
  public name: string = null;
  public entityType: string = null;
}
